<script>
  import ApplicationState from "../../../../Stores/applicationStates"
  import AuthStore, { UpdateAuthQRCode } from "../Stores/AuthStore"
  import { push } from "svelte-spa-router"
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../Shared/footer.svelte"
  import AuthInput from "../../../../Shared/authInput.svelte"
  import notify from "../../../../Script/notify"
  import { onMount } from "svelte"
  import { getRequest, postRequest } from "../../../../Script/apiMethods"

  // let valid = false
  let openModal = false
  let code = ""
  let emailValue = ""
  let submitBtn = true
  let emailerrnotify = {
    close() {},
  }

  let disbleBtn = false
  /**
   * @type {RegExp} regex pattern for validating the email address
   */
  const emailAddressPattern = /^[A-Z0-9.!#$%&'+/=?^_`{|}~-]+@[A-Z0-9-]+(?:\.[A-Z0-9-]+){1,}$/i

  let emailInputEnabled = false
  let enableCount = 0

  onMount(() => {
    emailValue = $ApplicationState.email
  })

  const clickSentOTP = async () => {
    try {
      submitBtn = true
      disbleBtn = true
      emailValue = emailValue.trim()
      if (!emailAddressPattern.test(emailValue)) throw "Enter a Valid Email address"

      await getRequest(`/api/swagger/v2/2fa/authenticator?email=${emailValue}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      openModal = true
    } catch (error) {
      // Show an error notification
      console.error(error)
      const info = "PAGE: 2F Authentication\nEVENT: While verifying email address by sending OTP"
      emailerrnotify.close()
      emailerrnotify = notify.danger(error, info)
    } finally {
      disbleBtn = false
    }
  }

  const checkOTP = async (e) => {
    try {
      let target = e.detail.target
      code = target[0].value + target[1].value + target[2].value + target[3].value + target[4].value + target[5].value

      const { authQRcode } = await postRequest(
        `/api/swagger/v2/2fa/authenticator`,
        { otp: code },
        {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        }
      )

      $AuthStore.QRCode = authQRcode
      UpdateAuthQRCode($AuthStore)
      openModal = false
      push("/settings/integration/authenticator/success")
    } catch (error) {
      // Show an error notification
      submitBtn = false
      code = ""
      const info = "PAGE: 2F Authentication\nEVENT: While verifying OTP send to the email address"
      emailerrnotify = notify.danger(error, info)
      emailerrnotify = notify.info("The OTP sent to your email has expired. Please click the 'Resend' button to generate a new OTP.")
    }
  }
</script>

<svelte:head>
  <title>2F Authentication</title>
</svelte:head>

<div class="relative min-h-screen w-full bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class="px-6">
    <div class="mx-auto h-auto w-full max-w-[920px] select-none pb-40 pt-6">
      <form on:submit|preventDefault|stopPropagation={clickSentOTP} class="relative mt-6 flex min-h-[470px] flex-col justify-between rounded-md bg-white p-6 dark:bg-mdGray md:p-12">
        <div class="space-y-3">
          <h1 class="lineHeight text-3xl font-extrabold dark:text-white mobile:text-5xl">
            Authenticator <br />
            App
          </h1>
          <p class="w-full text-gray-200 lg:w-3/5">To link your authenticator app with this account, please provide your email address to receive an OTP.</p>

          <div class="w-full pt-6">
            <!-- <input type="text" class="rounded-md text-lg font-medium" /> -->
            <p class="mb-1 text-sm font-medium text-gray-200">Email ID</p>
            {#if !emailInputEnabled}
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <div
                on:click={() => {
                  enableCount++
                  if (enableCount == 10) {
                    emailInputEnabled = true
                  }
                }}
                class="min-h-[36px] w-full rounded-md bg-[#f7f7f7] px-5 py-2 text-sm text-gray-800 dark:bg-bodyblack dark:text-white mobile:w-3/4 sm:w-3/4 md:w-1/2"
              >
                {emailValue || "Please provide a valid email ID."}
              </div>
            {:else}
              <div class="relative w-full mobile:w-3/4 sm:w-3/4 md:w-1/2">
                <input bind:value={emailValue} on:blur={() => (emailValue = emailValue.trim())} type="text" class="w-full rounded-md border border-[#a0a1a580] bg-transparent py-2 pr-9 pl-5 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 disabled:cursor-not-allowed disabled:placeholder:text-red-500 dark:text-white" placeholder="Enter Email ID" />
                <button
                  on:click={() => {
                    emailInputEnabled = false
                    enableCount = 0
                  }}
                  disabled={!emailValue.trim()}
                  type="button"
                  class="text absolute right-2 top-0 h-full text-blue-500 outline-none hover:text-blue-600 disabled:cursor-not-allowed"
                >
                  <div data-tooltip="Disable Input" tooltip-position="top">
                    <i class="fa-solid fa-pen-nib-slash" />
                  </div>
                </button>
              </div>
            {/if}
          </div>
        </div>

        <div class="flex items-center justify-end gap-3">
          <!-- <button
          href="#/settings/security/success"
          on:click={() => {
            push("/settings/integration")
          }}
          class="flex h-9 w-20 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f1f1f1] px-2 text-sm font-medium text-gray-700 hover:bg-[#d9d9d9] focus:outline-none active:bg-[#d9d9d9] disabled:cursor-not-allowed disabled:bg-blue-300 dark:bg-lightgray dark:text-white dark:hover:bg-bodyblack md:w-32 lg:px-4"
        >
          <i class="fa-solid fa-chevron-left" />
          &nbsp;&nbsp;Back
        </button> -->

          <button on:click={() => push("/settings/integration/authenticator/verify")} type="button" class="flex h-9 w-28 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-yellow-500 px-2 text-sm font-medium text-white hover:bg-yellow-600 hover:text-white focus:outline-none active:bg-yellow-500 disabled:cursor-not-allowed disabled:bg-yellow-300 mobile:w-36 lg:px-4">
            <i class="fa-solid fa-forward hidden mobile:flex" />
            &nbsp;&nbsp;Skip to Verify
          </button>
          <button type="submit" disabled={!emailValue || disbleBtn} class="flex h-9 w-28 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 mobile:w-36 lg:px-4">
            <i class="fa-solid fa-paper-plane-top hidden mobile:flex" />
            &nbsp;&nbsp;Send OTP
          </button>
        </div>
      </form>
    </div>
  </div>
  {#if openModal}
    <div class="fixed inset-0 z-10 flex items-center justify-center bg-[#000000cc] p-6 backdrop-blur-md">
      <div class="flex h-auto w-full items-center justify-center rounded-md bg-white p-6 dark:bg-bodyblack md:w-2/5">
        <AuthInput cancelBtn={true} on:click={() => (openModal = false)} on:submit={checkOTP} on:resendOTP={clickSentOTP} {submitBtn} resentBtn={true} {code} title="Enter OTP Received Through Email" />
      </div>
    </div>
  {/if}
  <Footer />
</div>

<style>
  .lineHeight {
    line-height: 4rem;
  }
</style>
